class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    document.addEventListener("cartdrawer:refresh", function (e) {
      this.doRefresh();
    }.bind(this));
  }

  doRefresh() {
    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      sections: sections,
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        this.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
          //this.registerCartAttributesListener();
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

}

if (!customElements.get('mini-cart')) {
  customElements.define('mini-cart', MiniCart);
}

// === Discount input lock helpers ===
function getDiscountInputEl() {
  return document.querySelector('#mini-cart__discount-form input[name="discount_code"]');
}
function setDiscountInputValue(val) {
  const el = getDiscountInputEl();
  if (el) el.value = val || '';
}
function lockDiscountInput(code) {
  const el = getDiscountInputEl();
  if (!el) return;
  if (code) el.value = code;
  el.readOnly = true;
  el.classList.add('is-readonly');
}
function unlockDiscountInput() {
  const el = getDiscountInputEl();
  if (!el) return;
  el.readOnly = false;
  el.classList.remove('is-readonly');
}
async function syncDiscountInputLock() {
  const root = (window.Shopify?.routes?.root || '/');
  const cart = await fetch(`${root}cart.js?ts=${Date.now()}`, { headers: { Accept: 'application/json' } }).then(r => r.json());
  
  const applicableCodes = (cart?.discount_codes || []).filter(dc => dc?.applicable);
  const hasCartLevel = Array.isArray(cart?.cart_level_discount_applications) && cart.cart_level_discount_applications.length > 0;
  const hasLineLevel = Array.isArray(cart?.items) && cart.items.some(i =>
    Array.isArray(i.line_level_discount_allocations) && i.line_level_discount_allocations.length > 0
  );

  if (hasCartLevel || hasLineLevel || applicableCodes.length) {
    const display = applicableCodes.map(dc => dc.code).filter(Boolean).join(', ');
    lockDiscountInput(display);
  } else {
    unlockDiscountInput();
    // clear stale attempt the browser might have restored on reload
    setDiscountInputValue('');
  }
}

/* === Mini cart discount (lazy-init + invalid-code detection) === */
(() => {
  if (window.__miniCartDiscountInitV5) return;
  window.__miniCartDiscountInitV5 = true;

  const ROOT = (window.Shopify?.routes?.root || '/');
  const SECTION_IDS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
  
  const getForm = () => {
    const form = document.querySelector('#mini-cart__discount-form');
    return form ? {
      form,
      input: form.querySelector('input[name="discount_code"]'),
      applyBtn: form.querySelector('[data-apply-discount]'),
      removeBtn: form.querySelector('[data-remove-discount]'),
      msg: form.querySelector('.mini-cart__discount-error')
    } : {};
  };

  const hasAnyDiscountDOM = () =>
    !!document.querySelector(
      '.taxes-discounts .discounts__discount, ' + // footer (cart-level)
      '.mini-cart__inner .discounts__discount'    // per-item (line-level)
    );

  const updateButtons = () => {
    const { applyBtn, removeBtn } = getForm();
    const hasAny = hasAnyDiscountDOM();
    if (applyBtn) applyBtn.hidden = !!hasAny;
    if (removeBtn) removeBtn.hidden = !hasAny;
  };

  async function renderSections(sections) {
    if (!sections) return;
    for (const [id, html] of Object.entries(sections)) {
      const t = document.querySelector(`[data-section-id="${id}"]`) || document.getElementById(id);
      if (!t) { continue; }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('.shopify-section')?.innerHTML || html;
      t.innerHTML = inner;
    }
    updateButtons();
  }

  async function fetchCart() {
    const res = await fetch(`${ROOT}cart.js?ts=${Date.now()}`, {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
    const json = await res.json();
    const cart = Array.isArray(json) ? { items: json } : json;
    return cart;
  }

  function analyzeResult(code, updateJson, cartJson) {
    const lc = (s) => (s || '').toLowerCase();
    const dcList = []
      .concat(updateJson?.discount_codes || [])
      .concat(updateJson?.cart?.discount_codes || [])
      .concat(cartJson?.discount_codes || []);
    const dc = dcList.find(d => lc(d?.code) === lc(code)) || dcList[0];

    const cartLevel = Array.isArray(cartJson?.cart_level_discount_applications) && cartJson.cart_level_discount_applications.length > 0;
    const lineLevel =
      (Array.isArray(updateJson?.items) && updateJson.items.some(i => (i?.line_level_discount_allocations || []).length > 0)) ||
      (Array.isArray(cartJson?.items) && cartJson.items.some(i => (i?.line_level_discount_allocations || []).length > 0));

    const applied = cartLevel || lineLevel;
    let reason = 'unknown';
    if (applied) reason = 'applied';
    else if (dc && dc.applicable === false) reason = 'inapplicable';
    else if (dc && dc.applicable === true) reason = 'shipping-only-or-later';
    else reason = 'notfound';

    return { applied, reason };
  }

  async function applyAjaxDiscount(code) {
    const payload = { discount: code, sections: SECTION_IDS, sections_url: '/cart' };


    const res = await fetch(`${ROOT}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });
    const updateJson = await res.json();
    await renderSections(updateJson.sections);
    const cartJson = await fetchCart();
    return analyzeResult(code, updateJson, cartJson);
  }

  // Initialize only when the drawer actually injects content
  function initHandlersOnce() {
    if (initHandlersOnce._done) return;
    initHandlersOnce._done = true;

    // Optional: ensure checkout remembers the code too
    function seedCheckoutCookie(code) {
      if (!code) return;
      const url = `${ROOT}discount/${encodeURIComponent(code)}?redirect=/cart`;
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = url;
      iframe.onload = () => iframe.remove();
      document.body.appendChild(iframe);
    }

    // Apply discount button click handler
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('#mini-cart__discount-form [data-apply-discount]');
      if (!btn) return;
      e.preventDefault();

      const { form, input } = getForm();
      const code = (input?.value || '').trim();
      if (!code) return;

      const pre = getForm().msg;
      if (pre) { pre.hidden = true; pre.textContent = ''; }
      form?.classList.add('is-loading');

      try {
        const { applied, reason } = await applyAjaxDiscount(code);

        // Re-acquire message after the drawer re-rendered
        const { msg } = getForm();
        if (applied) {
          if (msg) { msg.hidden = true; msg.textContent = ''; }
          lockDiscountInput(code);
          // Belt & suspenders: seed checkout session with the code
          seedCheckoutCookie(code);
        } else {
          if (msg) {
            msg.hidden = false;
            msg.textContent =
              (reason === 'shipping-only-or-later')
                ? `${code} is saved and will apply at checkout (e.g., shipping discount).`
                : `Oops! add more products / some products may not qualify`;
          }
        }
      } catch (err) {
        console.error('[mini-cart-discount] apply error', err);
        const { msg } = getForm();
        if (msg) { msg.hidden = false; msg.textContent = 'Something went wrong — please try again.'; }
      } finally {
        const { form } = getForm();
        form?.classList.remove('is-loading');
        updateButtons();
      }
    });

    // Remove
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('#mini-cart__discount-form [data-remove-discount]');
      if (!btn) return;
      e.preventDefault();

      const pre = getForm().msg;
      if (pre) { pre.hidden = true; pre.textContent = ''; }
      try {
        await applyAjaxDiscount('');
        const { input } = getForm();
        if (input) input.value = '';
      } catch (err) {
        console.error('[mini-cart-discount] remove error', err);
      } finally {
        updateButtons();
        unlockDiscountInput();
      }
    });

    // Keep UI in sync whenever your drawer re-renders its sections
    document.addEventListener('cart:updated', updateButtons);
    document.addEventListener('cartdrawer:opened', updateButtons);
    const drawer = document.querySelector('cart-drawer, .cart-drawer, mini-cart');
    if (drawer && 'MutationObserver' in window) {
      const obs = new MutationObserver(updateButtons);
      obs.observe(drawer, { childList: true, subtree: true });
    }

    updateButtons();
  }

  // 🔑 Defer setup until the drawer injects content
  document.addEventListener('cartdrawer:opened', initHandlersOnce, { once: true });
  document.addEventListener('cart:updated', syncDiscountInputLock);
  document.addEventListener('cartdrawer:opened', syncDiscountInputLock);
})();

/* === Suggested coupon → auto-fill + apply + hide suggestions === */
(() => {
  if (window.__cartDrawerSuggestedCouponInit) return;
  window.__cartDrawerSuggestedCouponInit = true;

  function getDiscountInput() {
    return document.querySelector('#mini-cart__discount-form input[name="discount_code"]');
  }
  function getApplyButton() {
    return document.querySelector('#mini-cart__discount-form [data-apply-discount]');
  }
  function hideSuggestions(scope) {
    const root = scope || document;
    root.querySelectorAll('.cart-drawer__discounts-wrapper2').forEach((el) => {
      // el.setAttribute('hidden', 'true');         // prefer attribute so CSS can key off it
      el.classList.add('is-hidden');             // optional: for themes that use classes
    });
  }
  function hasAnyDiscountDOM() {
    // Works for both cart-level (footer) and line-level (per item) discounts
    return !!document.querySelector(
      '.taxes-discounts .discounts__discount, .mini-cart__inner .discounts__discount'
    );
  }

  // 1) Handle clicks on the suggested coupon button (delegated)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart-drawer__discount-button');
    if (!btn) return;

    e.preventDefault();

    // Find the code near the clicked button
    const localContainer =
      btn.closest('.cart-drawer__discount-card') ||
      btn.closest('.cart-drawer__discounts-wrapper') ||
      btn.parentElement;

    const codeEl =
      (localContainer && localContainer.querySelector('.cart-drawer__discount-code')) ||
      document.querySelector('.cart-drawer__discount-code');

    const code = (codeEl?.textContent || '').trim();
    if (!code) {
      return;
    }

    // Fill the mini-cart input
    const input = getDiscountInput();
    if (!input) { return; }
    input.value = code;

    // Trigger your existing Apply flow
    const applyBtn = getApplyButton();
    if (applyBtn) {
      applyBtn.click();
    } else {
      // Fallback: fire a synthetic click for delegated handlers
      const target = document.querySelector('#mini-cart__discount-form [data-apply-discount]');
      if (target) {
        target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      } else {
      }
    }

    // Hide suggestions immediately
    hideSuggestions(localContainer || document);
    // Remember we hid them (so we can hide again after re-render)
    document.documentElement.dataset.suggestionsHidden = '1';
  });


  // 2) New version: Handle clicks on the suggested coupon button (delegated)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart-drawer__discount-code-container2');
    if (!btn) return;

    e.preventDefault();

    const code = (btn.dataset.code || '').trim();
    if (!code) {
      return;
    }

    // Fill the mini-cart input
    const input = getDiscountInput();
    if (!input) { return; }
    input.value = code;

    // Trigger your existing Apply flow
    const applyBtn = getApplyButton();
    if (applyBtn) {
      applyBtn.click();
    } else {
      // Fallback: fire a synthetic click for delegated handlers
      const target = document.querySelector('#mini-cart__discount-form [data-apply-discount]');
      if (target) {
        target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      } else {
      }
    }

    // Hide suggestions immediately
    hideSuggestions(localContainer || document);
    // Remember we hid them (so we can hide again after re-render)
    document.documentElement.dataset.suggestionsHidden = '1';
  });

  // 2) After cart re-renders / drawer opens, keep suggestions hidden if a discount is present or we already hid them
  const keepHidden = () => {
    if (document.documentElement.dataset.suggestionsHidden === '1' || hasAnyDiscountDOM()) {
      hideSuggestions(document);
    }
  };

  document.addEventListener('cart:updated', keepHidden);
  document.addEventListener('cartdrawer:opened', keepHidden);

  // 3) Also react to DOM swaps inside the drawer (lazy-loaded content)
  const drawer = document.querySelector('cart-drawer, .cart-drawer, mini-cart');
  if (drawer && 'MutationObserver' in window) {
    const obs = new MutationObserver(() => keepHidden());
    obs.observe(drawer, { childList: true, subtree: true });
  }
})();

/* === Suggested codes (rules + priority, max 2) === */
(() => {
  if (window.__suggestedCodesFilterInit) return;
  window.__suggestedCodesFilterInit = true;

  const ROOT = (window.Shopify?.routes?.root || '/');

  async function getCart() {
    const res = await fetch(`${ROOT}cart.js?ts=${Date.now()}`, {
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    });
    const raw = await res.json();
    return Array.isArray(raw) ? { items: raw, items_subtotal_price: 0 } : raw;
  }

  function cartHasVariant(cart, variantId) {
    const id = parseInt(variantId, 10);
    return (cart.items || []).some(it => it.variant_id === id);
  }

  function hide(el) {
    el.setAttribute('hidden', 'true');
    el.classList.add('is-hidden');
  }
  function show(el) {
    el.removeAttribute('hidden');
    el.classList.remove('is-hidden');
  }

  /*
   * evaluateOne — decides whether a single discount card should be visible.
   *
   * Reads data attributes from the .cart-drawer__discount-code-container2 element:
   *   data-code             – the discount code string (e.g. "HAPPY10")
   *   data-priority         – higher number = shown first when more than 2 codes are eligible
   *   data-always="true"    – always eligible (acts as a catch-all fallback); other constraints
   *                           can still be stacked on top of it in the future
   *   data-min-total        – minimum cart subtotal required, in Shopify minor units
   *                           (paise for INR: 500000 = ₹5,000)
   *   data-max-total        – maximum cart subtotal allowed, in minor units
   *   data-requires-variant – variant ID that must be present in the cart
   *
   * Returns { el, code, priority, eligible, reasons } so that runFilter() can
   * sort all eligible cards by priority and show only the top 2.
   */
  function evaluateOne(el, cart) {
    const code = (el.dataset.code || '').trim();
    const priority = parseInt(el.dataset.priority || '0', 10) || 0;
    const always = el.dataset.always === 'true';

    const min = el.dataset.minTotal ? parseInt(el.dataset.minTotal, 10) : null; // minor units
    const max = el.dataset.maxTotal ? parseInt(el.dataset.maxTotal, 10) : null; // minor units
    const reqVar = el.dataset.requiresVariant ? el.dataset.requiresVariant : null;

    const subtotal = cart.items_subtotal_price ?? 0;

    let ok = true;
    const reasons = [];

    if (always) {
      // still allow other constraints if you add them later
    }
    if (min !== null && subtotal < min) { ok = false; reasons.push(`subtotal<min(${min})`); }
    if (max !== null && subtotal > max) { ok = false; reasons.push(`subtotal>max(${max})`); }
    if (reqVar && !cartHasVariant(cart, reqVar)) { ok = false; reasons.push(`missingVariant(${reqVar})`); }

    return { el, code, priority, eligible: ok, reasons };
  }

  async function runFilter() {
    const MAX_VISIBLE_COUPONS = 3;

    const wrapper = document.querySelector('.cart-drawer__discounts-wrapper2');
    if (!wrapper) return;

    const blocks = Array.from(wrapper.querySelectorAll('.cart-drawer__discount-code-container2'));
    if (!blocks.length) return;

    const cart = await getCart();

    // Evaluate
    const evaluated = blocks.map(el => evaluateOne(el, cart));

    // Sort eligible by priority (desc), fallback to DOM order
    const eligible = evaluated
      .filter(x => x.eligible)
      .sort((a, b) => (b.priority - a.priority));

    const toShow = eligible.slice(0, MAX_VISIBLE_COUPONS).map(x => x.el);
    const toHide = new Set(blocks);
    toShow.forEach(el => toHide.delete(el));
    toShow.forEach(el => { show(el); });
    toHide.forEach(el => { hide(el); });

  }

  // Re-run when the drawer opens and when cart updates
  document.addEventListener('cartdrawer:opened', runFilter);
  document.addEventListener('cart:updated', runFilter);

  // Also react to DOM swaps inside the drawer
  const drawer = document.querySelector('cart-drawer, .cart-drawer, mini-cart');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(() => runFilter()).observe(drawer, { childList: true, subtree: true });
  }
  runFilter();
})();

/* === Cart drawer payment options sheet ===
   Markup: snippets/cart-payment-options.liquid
   All listeners are document-level and delegated, because MiniCart.renderContents()
   replaces #mini-cart's innerHTML wholesale on every cart update. */
(() => {
  if (window.__paySheetInit) return;
  window.__paySheetInit = true;

  const OPEN_CLASS = 'pay-sheet--open';

  function getSheet() {
    return document.querySelector('cart-payment-options.pay-sheet');
  }

  function getTrigger() {
    return document.querySelector('[data-open-pay-sheet]');
  }

  function isOpen() {
    const sheet = getSheet();
    return !!sheet && sheet.classList.contains(OPEN_CLASS);
  }

  function openSheet() {
    const sheet = getSheet();
    if (!sheet || sheet.classList.contains(OPEN_CLASS)) return;

    sheet.classList.add(OPEN_CLASS);
    sheet.setAttribute('aria-hidden', 'false');

    const trigger = getTrigger();
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    // The cart drawer already traps focus around <cart-drawer>, and the sheet lives
    // inside it — calling trapFocus() here would tear that trap down, so just move
    // focus into the panel instead.
    const panel = sheet.querySelector('.pay-sheet__panel');
    if (panel) panel.focus();
  }

  function closeSheet(returnFocus = true) {
    const sheet = getSheet();
    if (!sheet || !sheet.classList.contains(OPEN_CLASS)) return;

    sheet.classList.remove(OPEN_CLASS);
    sheet.setAttribute('aria-hidden', 'true');

    const trigger = getTrigger();
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) trigger.focus();
    }
  }

  // The button Fastrr injects into .shiprocket-headless. It only exists once their
  // script has run, so every caller has to cope with null.
  function getFastrrButton() {
    const sheet = getSheet();
    return sheet ? sheet.querySelector('.pay-sheet__option--fastrr .sr-headless-checkout') : null;
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-open-pay-sheet]')) {
      openSheet();
      return;
    }

    if (event.target.closest('[data-pay-sheet-close]')) {
      closeSheet();
      return;
    }

    // Option 2 (UPI / Wallet / Net Banking) has no Fastrr mount of its own — the script
    // supports one .shiprocket-headless per page — so it forwards its click to option 3's
    // real button. .click() dispatches straight at the element, so the pointer-events:none
    // proxy painted over it is irrelevant, and staying synchronous keeps us inside the
    // user gesture for anything Fastrr gates on user activation.
    if (event.target.closest('[data-pay-fastrr]')) {
      const fastrrButton = getFastrrButton();
      if (fastrrButton) {
        fastrrButton.click();
      } else {
        // Fastrr never injected — script blocked, or still loading. Send the customer to
        // Shopify checkout rather than leaving the button dead. Clicking a sibling submit
        // rather than calling form.requestSubmit() is deliberate: the cart form needs the
        // checkout button's own name/value in the POST body to redirect to checkout, and a
        // submitter-less submit would drop it.
        const sheet = getSheet();
        const fallback = sheet && sheet.querySelector('button[name="checkout"][type="submit"]');
        if (fallback) fallback.click();
      }
      return;
    }

    // Anything inside the sheet but outside the panel dismisses it — the backdrop,
    // and any gap the panel doesn't fill.
    if (!isOpen()) return;
    const sheet = getSheet();
    if (sheet.contains(event.target) && !event.target.closest('.pay-sheet__panel')) {
      closeSheet();
    }
  });

  // Capture phase: MenuDrawer binds 'keyup' on <cart-drawer> and would close the whole
  // drawer. Intercept first so Escape closes only the sheet while it is open.
  document.addEventListener('keyup', (event) => {
    if (!isOpen()) return;

    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode !== 'ESCAPE') return;

    event.stopPropagation();
    closeSheet();
  }, true);

  // The sheet is destroyed and rebuilt whenever the section re-renders, so make sure
  // it never lingers in the open state across a cart update or drawer reopen.
  document.addEventListener('cartdrawer:opened', () => closeSheet(false));
  document.addEventListener('cart:updated', () => closeSheet(false));
  document.addEventListener('menudrawer:close', () => closeSheet(false));
})();
